
import React from 'react';


export default function PolicyPage() {
  return (
    <div className="policy-container">
      <h1>Privacy Policy for Shoreline Defender App</h1>
      <p className="effective-date">Effective Date: May 20, 2025</p>
      <p>
        Shoreline Defender LLC ("we," "our," or "us") values your privacy. This Privacy Policy
        describes how we collect, use, and protect your information when you use the Shoreline
        Defender mobile application (the "App") or visit our website.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Location Data (App Only):</strong> We collect GPS data to show your real-time position relative to public beach access boundaries. This location data is essential to deliver core app functionality and generate boundary calculations accurately.</li>
        <li><strong>Activity Data:</strong> We record anonymous user interactions within the app (e.g., viewing access boundaries, submitting incident reports).</li>
        <li><strong>User Submissions:</strong> If you voluntarily submit an incident report in the app, we record only what you choose to provide (e.g., description, photos, timestamp). We do not request or collect names, emails, or contact information through the app at this time.</li>
        <li><strong>Email Submissions (Website Only):</strong> If you provide your email address via our website—for example, by signing up for a newsletter or submitting a form—we will collect and store it solely for communication purposes and not for resale or marketing by third parties.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To deliver accurate real-time mapping of public coastal access boundaries.</li>
        <li>To facilitate community-based reporting of access-related incidents.</li>
        <li>To improve app performance and develop aggregate usage metrics.</li>
        <li>To communicate with users who voluntarily submit contact information on our website.</li>
      </ul>

      <h2>3. Data Storage and Security</h2>
      <ul>
        <li>We use Firebase and AWS for secure storage of location and activity data.</li>
        <li>All data is encrypted in transit and at rest using industry best practices.</li>
      </ul>

      <h2>4. Sharing of Information</h2>
      <ul>
        <li>We do not sell, rent, or share your data with third parties for marketing.</li>
        <li>We may share aggregate, non-personal data for analytical purposes.</li>
        <li>Individual data may only be disclosed if legally required.</li>
      </ul>

      <h2>5. Your Rights</h2>
      <ul>
        <li>You may delete the app at any time to cease all app data collection.</li>
        <li>You may request deletion of any incident data you’ve submitted or email contact information you’ve shared via the website.</li>
      </ul>

      <h2>6. Children’s Privacy</h2>
      <p>This App is not intended for children under 13 and we do not knowingly collect personal information from them.</p>

      <h2>7. Changes to This Policy</h2>
      <p>Any future updates will be posted within the app and on our website.</p>

      <h2>8. Contact Us</h2>
      <p>
        For any privacy-related questions or data concerns:<br/>
        Shoreline Defender LLC<br/>
        1309 Coffeen Avenue, STE 1200<br/>
        Sheridan, WY 82801<br/>
        <a href="mailto:admin@shorelinedefenderapp.com">admin@shorelinedefenderapp.com</a>
      </p>

     
    </div>
  );
}

